import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-channel-one-dots',
  templateUrl: './channel-one-dots.component.html',
  styleUrls: ['./channel-one-dots.component.scss']
})
export class ChannelOneDotsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
